import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { TabItem } from '@shared/models/instructor-sidebar-constant';
import { AngularSvgIconModule } from 'angular-svg-icon';
import * as _ from 'lodash';

@Component({
  selector: 'app-common-tab-menu',
  templateUrl: './tab-menu.component.html',
  styleUrls: ['./tab-menu.component.scss'],
  standalone: true,
  imports: [NgIf, NgFor, AngularSvgIconModule, NgClass, RouterLink],
})
export class TabMenuComponent {
  @Input() items: TabItem[] = [];
  @Input() title: string = '';
  @Input() type: string = 'assignments';
  @Input() endPath: string = '';
  preview: boolean = false;
  queryParams: { preview: boolean } = {
    preview: true,
  };

  // @Output() item = new EventEmitter<Item>();
  parentRoute: string = '';
  activeItem: string = '/';

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    this.getActive();
    router.events.forEach((event) => {
      // TODO: replace by state route
      if (event instanceof NavigationEnd) this.getActive();
    });
    this.preview = this.activatedRoute.snapshot.queryParams['preview'] === 'true';
  }

  getActive() {
    this.activeItem = '/' + _.last(this.router.url.split('/'));
    // console.log(this.router.url.split('/')[this.router.url.split('/').length - 1]);
    this.parentRoute = this.router.url.replace(this.activeItem, '');
    // this.item.emit({
    //   current: this.activeItem,
    //   parent: this.parentRoute,
    // });
  }
}
